// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__LHMNA","tooltip__text":"styles_tooltip__text__pri3H"};